// GraphQL 에러 타입 정의
export const GRAPHQL_ERROR_TYPES = {
  PERMISSION_DENIED: 'PERMISSION_DENIED'
};

// 권한 에러인지 체크
export const isPermissionError = (errorType) => {
  return errorType === GRAPHQL_ERROR_TYPES.PERMISSION_DENIED;
};

// 권한 에러 메시지 추출
export const extractPermissionErrorMessage = (error) => {
  return error?.message || '접근 권한이 없습니다.';
}; 